/* global window:true */

import React from 'react';
import PropTypes from 'prop-types';
import { Modes, DataDtmActions } from '../common/Constants';
import Tags from '../common/dtmTags';
import ShowPlanService from '../common/api/ShowPlanService';
import FavouriteUpdateListener from '../common/components/FavouriteUpdateListener';
import AlgoliaWrapper from './algolia/AlgoliaWrapper';
import TranslationService from '../translations';
import ExhibitorRecommendationCTAButton from '../recommendation/ExhibitorRecommendationCTAButton';
import { trackMixpanelEvent } from '../common/MixpanelHelper';
import mixpanelConstants from '../common/mixpanelConstants';
import SurveyBanner from '../SurveyBanner/SurveyBanner';
import surveyBannerConfig from '../SurveyBanner/SurveyBannerConfig';

let indexName;

class DirectoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPlan: {},
      isExhibitorDirectoryRecommendationEnabled: false
    };

    this.translations = TranslationService.getTranslations(props.context.interfaceLocale);
    indexName = this.getIndexName()
  }

  getIndexName = () => {
    return `${this.props.context.eventId}-index`
  }

  componentDidMount() {
    const {
      context, baseApiUrl, showPlanId
    } = this.props;

    if (context.showPlanningEnabled) {
      this.getCurrentShowPlan(context, baseApiUrl, showPlanId);
      window.addEventListener('pageshow', this.handlePageLoadedFromCache);
    }
    trackMixpanelEvent(mixpanelConstants.eventName.exhibitorDirectoryVisited, {
      component: mixpanelConstants.component.exhibitorDirectory
    })
    console.log('Track Exhibitor Directory visited event in mixpanel');
  }

  getCurrentShowPlan = (context, baseApiUrl, showPlanId) => {
    ShowPlanService.getShowPlan(baseApiUrl, context.eventEditionId, showPlanId)
      .then(serviceResult => this.setState({ showPlan: serviceResult.showPlan }));
  }

  handlePageLoadedFromCache = (event) => {
    if (event.persisted) {
      this.getCurrentShowPlan(this.props.context, this.props.baseApiUrl, this.props.showPlanId);
    }
  }

  updatedShowPlan = (updatedShowPlan) => {
    this.setState({
      showPlan: updatedShowPlan
    });
  };

  render() {
    const { showPlan } = this.state;
    const {
      assets, context, navigation, algoliaConfig = {}, testVariants
    } = this.props;
    const pageTitle = decodeURIComponent(window?.reactSettings?.props?.context?.title) || '';

    return (
      <div>
        <FavouriteUpdateListener
          showPlan={showPlan}
          showPlanningEnabled={this.props.context.showPlanningEnabled}
          favouriteCallback={this.updatedShowPlan}
          unfavouriteCallback={this.updatedShowPlan}
        />
        <div data-dtm={Tags.exhibitorDirectory.component} data-dtm-actions={DataDtmActions.view}>
          {
            <AlgoliaWrapper
              baseApiUrl={this.props.baseApiUrl}
              eventEditionId={context.eventEditionId}
              locale={context.interfaceLocale}
              appId={algoliaConfig.appId}
              indexName={indexName}
              apiKey={algoliaConfig.apiKey}
              navigation={navigation}
              context={context}
              assets={assets}
              testVariants={testVariants}
              showPlan={showPlan}
              pageTitle={pageTitle}
              directoryPage={'exhibitor'}
            />
          }
        </div>
        {
          this.state.isExhibitorDirectoryRecommendationEnabled &&
          <ExhibitorRecommendationCTAButton
            baseApiUrl={this.props.baseApiUrl}
            eventEditionId={context.eventEditionId}
            interfaceLocale={this.props.context.interfaceLocale}
            exhibitorDirectoryRecommendationTranslations={this.translations.directory.exhibitorDirectoryRecommendation}
          />
        }
        {/*<div className={'xplore'}>*/}
        {/*    <SurveyPopup surveyUri={Utils.getVerintSurveyUri('surveyUri') + `?eve_id=${context.eventEditionId}`}/>*/}
        {/*    <FeedbackButton feedbackText={this.translations.directory.feedBackButtonText}*/}
        {/*        dataDtm={Tags.exhibitorDirectory.feedbackButton}/>*/}
        {/*</div>*/}

        <SurveyBanner translations={this.translations.directory?.surveyBanner}
          surveyLink={surveyBannerConfig.surveyLinkExhibitorDirectory}
          eventId={context.eventId}
          bannerType='FeedbackLabel'
        />

      </div>
    );
  }
}

DirectoryPage.propTypes = {
  assets: PropTypes.shape({
    defaultOrganisationListingLogoUrl: PropTypes.string.isRequired
  }).isRequired,
  navigation: PropTypes.shape({
    exhibitorPublicDetailsUrlFormat: PropTypes.string.isRequired
  }).isRequired,
  context: PropTypes.shape({
    eventEditionId: PropTypes.string.isRequired,
    eventId: PropTypes.string.isRequired,
    interfaceLocale: PropTypes.string.isRequired,
    primaryLocale: PropTypes.string.isRequired,
    mode: PropTypes.oneOf([Modes.private, Modes.protected, Modes.public]),
    showPlanningEnabled: PropTypes.bool,
    tenants: PropTypes.string
  }).isRequired,
  algoliaConfig: PropTypes.shape({
    appId: PropTypes.string.isRequired,
    apiKey: PropTypes.string.isRequired
  }).isRequired,
  testVariants: PropTypes.arrayOf(PropTypes.string),
  baseApiUrl: PropTypes.string.isRequired,
  showPlanId: PropTypes.string.isRequired
};

export default DirectoryPage;
